module.exports = __webpack_public_path__ + "images/_/programs/epsHybridIntermediates/images/characters/ian_sara_two_fingers-5ed565638eae000314880d23ff009b43.png";


//////////////////
// WEBPACK FOOTER
// ./programs/epsHybridIntermediates/images/characters/ian_sara_two_fingers.png
// module id = 2278
// module chunks = 2